import React from "react";

import { replaceAll } from "../../components/Base/mol_function";
import { ShoppingCartPageItemModel } from "./Model";

interface WebgainsBasketTagProps {
  items: ShoppingCartPageItemModel[];
}

export default class WebgainsBasketTag extends React.Component<
  WebgainsBasketTagProps
> {
  render() {
    let products = [];

    for (let i = 0; i < this.props.items.length; i++) {
      let p = {
        id: +this.props.items[i].id,
        qty: this.props.items[i].quantity,
        price: this.props.items[i].item_price,
        name: this.props.items[i].name
      };
      products.push(p);
    }

    let js =
      `window.ntmData=window.ntmData||[];
      window.ntmData.push({
      gdpr: "-1", /* 0 if GDPR does not apply, 1 if GDPR applies */
      gdprConsent: "", /* IAB TCF 2.0 consent string */
      pageType:"basket",
      products: ` +
      JSON.stringify(products) +
      `
      });
        `;

    return (
      <script type="text/javascript" dangerouslySetInnerHTML={{ __html: js }} />
    );
  }
}
